import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    EmbeddedAppPositionsState,
    initialEmbeddedAppState,
    OrderIdsSource,
} from './EmbeddedAppState';
import { Action } from 'store/store';
import State from 'store/State';

const embeddedAppStateSlice = createSlice({
    name: 'embeddedApp',
    initialState: initialEmbeddedAppState,
    reducers: {
        setOrderIds: (
            state,
            action: PayloadAction<{
                orderIds: string[];
                source: OrderIdsSource;
            }>
        ) => {
            return {
                orderIds: action.payload!.orderIds,
                orderIdsSource: action.payload!.source,
                alerts: state.alerts,
                stylesheetUrl: state.stylesheetUrl,
                hostBorderPx: state.hostBorderPx,
            };
        },
        setPositions: (
            state,
            action: PayloadAction<EmbeddedAppPositionsState>
        ) => {
            return {
                positions: action.payload,
                alerts: state.alerts,
                stylesheetUrl: state.stylesheetUrl,
                hostBorderPx: state.hostBorderPx,
            };
        },

        clearPortfolio: (state) => {
            return {
                alerts: [],
                stylesheetUrl: state.stylesheetUrl,
                hostBorderPx: state.hostBorderPx,
            };
        },

        setAlerts: (state, action: PayloadAction<string[]>) => {
            state.alerts = action.payload;
        },
        setStylesheetUrl: (
            state,
            action: PayloadAction<{ stylesheetUrl: string }>
        ) => {
            state.stylesheetUrl = action.payload.stylesheetUrl;
        },
        hideWindowButtons: (state) => {
            state.hideWindowButtons = true;
        },

        setHostBorderPx: (
            state,
            action: PayloadAction<{ hostBorderPx: number }>
        ) => {
            state.hostBorderPx = action.payload.hostBorderPx;
        },
    },
});

export const isEmbeddedAppPortfolioAction = (action: Action<unknown>) =>
    action.type === embeddedAppStateSlice.actions.setOrderIds.type ||
    action.type === embeddedAppStateSlice.actions.setPositions.type ||
    action.type === embeddedAppStateSlice.actions.clearPortfolio.type;

export const selectEmbeddedAppState = (state: State) => state.embeddedApp;

export const selectEmbeddedAppOrderIds = (state: State) => {
    const embeddedAppState = selectEmbeddedAppState(state);
    return embeddedAppState.orderIds;
};

export const selectEmbeddedAppOrderIdsSource = (state: State) => {
    const embeddedAppState = selectEmbeddedAppState(state);
    return embeddedAppState.orderIdsSource;
};

export const selectEmbeddedAppPositions = (state: State) => {
    const embeddedAppState = selectEmbeddedAppState(state);
    return embeddedAppState.positions;
};

export const selectEmbeddedAppAlerts = (state: State) =>
    selectEmbeddedAppState(state).alerts;

export const embeddedAppStateActions = embeddedAppStateSlice.actions;

export default embeddedAppStateSlice.reducer;
